import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToken } from "../context/TokenContext";
import { supabase } from "../supabaseClient";
import { useFal } from "../context/FalContext";
import YildizArkaplan from "../components/YildizArkaplan";

const cleanMarkdown = (text) => text
  .replace(/##\s*/g, '')
  .replace(/\*\*(.*?)\*\*/g, '$1')
  .replace(/\*(.*?)\*/g, '$1')
  .replace(/#{1,6}\s*/g, '');

const BOLUM_BASLIKLAR = [
  { key: "atmosfer", baslik: "🌙 Genel Atmosfer", renk: "rgba(139,92,246,0.15)", border: "rgba(139,92,246,0.4)" },
  { key: "bilincalti", baslik: "🧠 Bilinçaltı Yorumu", renk: "rgba(109,40,217,0.15)", border: "rgba(109,40,217,0.4)" },
  { key: "mesaj", baslik: "✨ Olası Mesaj", renk: "rgba(167,139,250,0.12)", border: "rgba(167,139,250,0.35)" },
  { key: "sonDegerlendirme", baslik: "🔮 Son Değerlendirme", renk: "rgba(91,33,182,0.2)", border: "rgba(167,139,250,0.5)" },
];

export default function RuyaTabiri() {
  const navigate = useNavigate();
  const { user, tokenBalance, harcaToken } = useToken();
  const { fetchFallar } = useFal();
  const [ruyaMetni, setRuyaMetni] = useState("");
  const [loading, setLoading] = useState(false);
  const [yorum, setYorum] = useState(null);
  const [hata, setHata] = useState("");

  const TOKEN_MIKTAR = 60;
  const yetersizToken = tokenBalance < TOKEN_MIKTAR;

  async function yorumla() {
    if (!ruyaMetni.trim()) { setHata("Lütfen rüyanı anlat."); return; }
    if (yetersizToken) return;
    setHata("");
    setLoading(true);

    const basarili = await harcaToken(TOKEN_MIKTAR, "ruya");
    if (!basarili) {
      setHata("Token harcama başarısız.");
      setLoading(false);
      return;
    }

    try {
      const { data, error } = await supabase.functions.invoke("ruya-yorumu", {
        body: { ruyaMetni, userId: user.id },
      });

      if (error || !data?.success) throw new Error(data?.error || "Yorum alınamadı.");

      

      const tamYorum = [
        data.atmosfer && `Genel Atmosfer:\n${data.atmosfer}`,
        data.duygusal && `Duygusal Analiz:\n${data.duygusal}`,
        data.semboller && `Sembol Bağlantıları:\n${data.semboller}`,
        data.bilincalti && `Bilinçaltı Yorumu:\n${data.bilincalti}`,
        data.mesaj && `Olası Mesaj:\n${data.mesaj}`,
        data.sonDegerlendirme && `Son Değerlendirme:\n${data.sonDegerlendirme}`,
      ].filter(Boolean).join("\n\n");

      const { data: kayit, error: kayitHata } = await supabase.from("fallar").insert({
        user_id: user.id,
        falci_id: "efsun-hanim",
        fal_turu: "ruya",
        durum: "bekliyor",
        token_harcanan: TOKEN_MIKTAR,
        yorum: tamYorum,
        ek_not: ruyaMetni,
        foto_urls: [],
        hazir_olma_zamani: new Date(Date.now() + 10 * 60 * 1000).toISOString(),
      }).select("id").single();

      if (kayitHata || !kayit) throw new Error("Rüyan kaydedilemedi, lütfen tekrar dene.");

      await fetchFallar();
      navigate("/fal-detay/" + kayit.id);
    } catch (err) {
      setHata(err.message || "Bir hata oluştu.");
    } finally {
      setLoading(false);
    }
  }

  function sifirla() {
    setYorum(null);
    setRuyaMetni("");
    setHata("");
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(180deg, #0d0520 0%, #150c35 40%, #0a0718 100%)",
      position: "relative",
      overflow: "hidden",
      fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
      maxWidth: 420,
      margin: "0 auto",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@700&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { display: none; }
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes yorum-gir { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>

      <YildizArkaplan />
      <div style={{ position: "absolute", top: -80, left: "50%", transform: "translateX(-50%)", width: 400, height: 400, borderRadius: "50%", background: "radial-gradient(circle, rgba(100,40,180,0.2) 0%, transparent 65%)", pointerEvents: "none" }} />

      <div style={{ position: "relative", zIndex: 1, paddingBottom: 100 }}>

        {/* Geri */}
        <div style={{ padding: "16px 20px 0" }}>
          <button
            onClick={() => navigate(-1)}
            style={{ background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 12, padding: "8px 16px", color: "rgba(255,255,255,0.7)", fontSize: 13, cursor: "pointer" }}
          >
            ← Geri
          </button>
        </div>

        {/* Karakter Kartı */}
        <div style={{ margin: "16px 16px 0", borderRadius: 22, background: "linear-gradient(145deg, #1a0a2e, #2d1b4e, #3d2468)", border: "1px solid rgba(167,139,250,0.3)", padding: "24px 20px", textAlign: "center" }}>
          <img
            src="/efsunhanim.png"
            alt="Efsun Hanım"
            style={{ width: 100, height: "auto", borderRadius: 0, objectFit: "contain", border: "none", background: "none", marginBottom: 12 }}
          />
          <div style={{ fontFamily: "'Cinzel', serif", fontSize: 22, fontWeight: 700, color: "#fff", marginBottom: 4 }}>Efsun Hanım</div>
          <div style={{ fontSize: 12, color: "rgba(167,139,250,0.8)", marginBottom: 10, letterSpacing: 1 }}>Rüya Tabircisi</div>
          <div style={{ fontSize: 13, color: "rgba(255,255,255,0.45)", fontStyle: "italic", lineHeight: 1.5, marginBottom: 14 }}>
            "Bazı rüyalar unutulmaz… Çünkü sadece rüya değildir."
          </div>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 5, background: "rgba(249,203,66,0.15)", border: "1px solid rgba(249,203,66,0.4)", borderRadius: 20, padding: "6px 16px", fontSize: 13, color: "#F9CB42", fontWeight: 700 }}>
            🪙 {TOKEN_MIKTAR} Token
          </div>
        </div>

        {!yorum ? (
          <>
            {/* Yönlendirme */}
            <div style={{ margin: "16px 16px 0", borderRadius: 16, background: "rgba(255,255,255,0.04)", border: "1px solid rgba(167,139,250,0.15)", padding: "16px 18px" }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "rgba(255,255,255,0.85)", marginBottom: 10 }}>
                Rüyanı mümkün olduğunca detaylı anlat:
              </div>
              {[
                "Kimler vardı",
                "Nerede geçiyordu",
                "Hangi duyguları hissettin",
                "En çok aklında kalan semboller neydi",
                "Rüya nasıl başladı ve bitti",
              ].map((madde, i) => (
                <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 6 }}>
                  <span style={{ color: "rgba(167,139,250,0.6)", fontSize: 11, marginTop: 1 }}>•</span>
                  <span style={{ fontSize: 12, color: "rgba(255,255,255,0.45)", lineHeight: 1.4 }}>{madde}</span>
                </div>
              ))}
            </div>

            {/* Form */}
            <div style={{ padding: "12px 16px 0" }}>
              <textarea
                value={ruyaMetni}
                onChange={(e) => setRuyaMetni(e.target.value)}
                placeholder="Rüyanı buraya yaz... Ne kadar detaylı anlatırsan yorum o kadar derin olur."
                style={{
                  width: "100%",
                  minHeight: 200,
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(167,139,250,0.35)",
                  borderRadius: 16,
                  padding: "14px 16px",
                  color: "#fff",
                  fontSize: 14,
                  lineHeight: 1.6,
                  resize: "vertical",
                  outline: "none",
                  fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
                }}
              />

              {hata && (
                <div style={{ marginTop: 8, fontSize: 12, color: "#F87171", background: "rgba(248,113,113,0.1)", border: "1px solid rgba(248,113,113,0.3)", borderRadius: 10, padding: "8px 12px" }}>
                  {hata}
                </div>
              )}

              {yetersizToken && (
                <div style={{ marginTop: 8, fontSize: 12, color: "#F9CB42", background: "rgba(249,203,66,0.08)", border: "1px solid rgba(249,203,66,0.25)", borderRadius: 10, padding: "8px 12px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>Yetersiz token ({tokenBalance} / {TOKEN_MIKTAR})</span>
                  <span
                    onClick={() => navigate("/token-kazan")}
                    style={{ color: "#F9CB42", fontWeight: 700, cursor: "pointer", textDecoration: "underline" }}
                  >
                    Token Al →
                  </span>
                </div>
              )}

              <button
                onClick={yorumla}
                disabled={loading || yetersizToken}
                style={{
                  marginTop: 12,
                  width: "100%",
                  padding: "16px",
                  borderRadius: 16,
                  background: loading || yetersizToken
                    ? "rgba(139,92,246,0.2)"
                    : "linear-gradient(135deg, #4c1d95, #7c3aed)",
                  border: "1px solid rgba(139,92,246,0.5)",
                  color: loading || yetersizToken ? "rgba(255,255,255,0.4)" : "#fff",
                  fontSize: 15,
                  fontWeight: 700,
                  cursor: loading || yetersizToken ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                }}
              >
                {loading ? (
                  <>
                    <div style={{ width: 18, height: 18, border: "2px solid rgba(255,255,255,0.3)", borderTopColor: "#fff", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
                    Efsun Hanım rüyanı yorumluyor...
                  </>
                ) : (
                  "Rüyamı Yorumla 🔮"
                )}
              </button>
            </div>
          </>
        ) : (
          /* Yorum Sonucu */
          <div style={{ padding: "16px 16px 0" }}>
            <div style={{ fontSize: 11, color: "rgba(167,139,250,0.7)", letterSpacing: 2, textTransform: "uppercase", fontWeight: 600, marginBottom: 12, textAlign: "center" }}>
              ✦ Rüya Yorumun
            </div>

            {BOLUM_BASLIKLAR.map((bolum, i) => {
              const icerik = yorum[bolum.key];
              if (!icerik) return null;
              return (
                <div
                  key={bolum.key}
                  style={{
                    borderRadius: 16,
                    background: bolum.renk,
                    border: `1px solid ${bolum.border}`,
                    padding: "16px 18px",
                    marginBottom: 10,
                    animation: "yorum-gir 0.5s ease backwards",
                    animationDelay: `${i * 100}ms`,
                  }}
                >
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#fff", marginBottom: 8 }}>{bolum.baslik}</div>
                  <div style={{ fontSize: 15, color: "rgba(255,255,255,0.8)", lineHeight: 1.75 }}>{cleanMarkdown(icerik)}</div>
                </div>
              );
            })}

            <button
              onClick={sifirla}
              style={{
                marginTop: 8,
                width: "100%",
                padding: "14px",
                borderRadius: 16,
                background: "rgba(139,92,246,0.15)",
                border: "1px solid rgba(139,92,246,0.4)",
                color: "rgba(167,139,250,0.9)",
                fontSize: 14,
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              🌙 Yeni Rüya Yorumla
            </button>
          </div>
        )}

      </div>
    </div>
  );
}
